import React from "react";
import { usePermissions } from "../../../context/PermissionsContext";

// Renders children only if the user has the specified Bouncer permission.
const _WithPermission = ({ permission, children }) => {
  const { hasPermission } = usePermissions();
  return hasPermission(permission) ? <>{children}</> : null;
};

export const WithPermission = React.memo(_WithPermission);

